import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('bis/word')

export default {
  async created () {
    await this.$$loadWords()
  },
  computed: {
    ...mapGetters({
      $$getWord: 'getWord',
      $$getWordText: 'getWordText',
      $$getWordsListByType: 'getWordsListByType',
      $$getWordsMapByType: 'getWordsMapByType',
      $$getWordsOptionsByType: 'getWordsOptionsByType',
      $$getWordByText: 'getWordByText',
      $$getWordLabelByType: 'getWordLabelByType',
      $$getWordIconByType: 'getWordIconByType'
    })
  },
  methods: {
    ...mapActions({
      $$loadWords: 'loadWords'
    })
  }
}
